var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"m-4"},[_c('spinner-icon'),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Please wait. Requesting authorization...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }